export default "__VITE_ASSET__BUdkBegd__"